import React from 'react';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V2ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { V2Button } from '@uhg-abyss/web/ui/Button';

export const NpiValidationModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <V2ModalDialog
      id="verify-tin-npi-validation-modal"
      isOpen={isOpen}
      header="Unable to Verify NPI"
    >
      NPI(s) entered could not be verified. Please check for errors and try
      again.
      <br />
      <br />
      Do you want to continue?
      <Layout.Group alignLayout="right" css={{ marginTop: '24px' }}>
        <V2Button onClick={onConfirm}>Yes</V2Button>
        <V2Button variant="outline" onClick={onCancel}>
          No
        </V2Button>
      </Layout.Group>
    </V2ModalDialog>
  );
};
